import React, { useEffect, useState } from "react";

import { CustomSwitch } from "src/app/components/CustomSwitch/CustomSwitch";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { MaterialTooltip } from "src/app/components/MaterialTooltip/MaterialTooltip";
import allRangeOptions from "./utils/followerRangeOptions";
import CustomFollowersRange, { emptyRange } from "./CustomFollowersRange";
import FollowersRangeTags from "./FollowerRangeTags";

const hasRangeTags = (influencerFollowers) => {
  return influencerFollowers.every(
    (item) =>
      allRangeOptions.findIndex(
        (option) => option.min === item.min && option.max === item.max,
      ) > -1,
  );
};

export default function FollowersRange({
  influencerFollowers,
  setInfluencerFollowers,
  influencerSocialUsername,
  isExpandableRangeTags,
}) {
  const [isCustomRange, setIsCustomRange] = useState(false);

  const selectedRangeTags = hasRangeTags(influencerFollowers)
    ? influencerFollowers
    : [];
  const customRange =
    influencerFollowers.length > 0 ? influencerFollowers[0] : emptyRange;

  useEffect(() => {
    if (influencerFollowers.length === 0) return;

    if (!hasRangeTags(influencerFollowers) && !isCustomRange) {
      setIsCustomRange(true);
    }
  }, [influencerFollowers]);

  return (
    <div
      className="audience-search__followers-range"
      data-qa="filter_influencer_followers"
    >
      <div className="idh-label idh-label--with-tooltip mb-12">
        <IDHFormattedMessage
          id="front_follower_range"
          defaultMessage="Follower range"
        />
        <MaterialTooltip
          id="front_follower_range_tooltip"
          content={
            <IDHFormattedMessage
              id="front_follower_range_tooltip"
              defaultMessage="Here you can specify the range of followers you are searching for."
            />
          }
        />
      </div>

      <div className="audience-search__followers-range-fields">
        {!isCustomRange && (
          <div className="audience-search__field">
            <FollowersRangeTags
              selectedRangeTags={selectedRangeTags}
              setSelectedRangeTags={setInfluencerFollowers}
              isExpandable={isExpandableRangeTags}
              disabled={influencerSocialUsername.length > 0}
            />
          </div>
        )}

        <CustomSwitch
          label={
            <IDHFormattedMessage
              id="front_custom_range"
              defaultMessage="Custom range"
            />
          }
          checked={isCustomRange}
          onChange={() => {
            setInfluencerFollowers([]);
            setIsCustomRange((prev) => !prev);
          }}
        />

        {isCustomRange && (
          <CustomFollowersRange
            customRange={customRange}
            setCustomRange={setInfluencerFollowers}
            disabled={influencerSocialUsername.length > 0}
          />
        )}
      </div>
    </div>
  );
}
